"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.urlFields = exports.lowerFields = exports.hostFields = exports.functions = void 0;
/* eslint-disable quotes */
// these escaped strings work better as templates otherwise they sometimes end up as un-escaped
const functions = exports.functions = [{
  label: 'TLD',
  value: `[^.]+\\.([^.]+)$`,
  selector: '$1',
  host: true,
  url: false
}, {
  label: 'Domain',
  value: `([^.]+\\.[^.]+)$`,
  selector: '$1',
  host: true,
  url: false
}, {
  label: 'Subdomain',
  value: `([^.]+\\.[^.]+\\.[^.]+)$`,
  selector: '$1',
  host: true,
  url: false
}, {
  label: 'Host',
  value: `(^.*)\\.[^.]+\\.[^.]+$`,
  selector: '$1',
  host: true,
  url: false
}, {
  label: 'Path',
  value: `(^.*)/.*(\\?)+`,
  selector: '$1',
  host: false,
  url: true
}, {
  label: 'Filename',
  value: `^.*(/.*)(\\?)+`,
  selector: '$1',
  host: false,
  url: true
}, {
  label: 'File Path',
  value: `(^.*)(\\?)+`,
  selector: '$1',
  host: false,
  url: true
}, {
  label: 'Query String',
  value: `^.*[\\?]+(.*)`,
  selector: '$1',
  host: false,
  url: true
}];
const hostFields = exports.hostFields = ['kflow_dns_query', 'kflow_http_host', 'c_dst_dns_query', 'c_src_dns_query', 'service_name', 'ktappprotocol__dns__STR00', 'ktappprotocol__dns__STR01', 'ktappprotocol__dhcp__STR01', 'ktappprotocol__dhcp__STR02', 'ktappprotocol__http__STR01', 'ktappprotocol__tls__STR00'];
const urlFields = exports.urlFields = ['kflow_http_url', 'ktappprotocol__http__STR00', 'ktappprotocol__http__STR02'];
const lowerFields = exports.lowerFields = ['ktappprotocol__dns__STR00'];